import { useState } from "react";

export type MaxItemsState = {
  maxItems: number;
  initialMaxItems: number;
  increaseMaxItems: () => void;
  resetMaxItems: () => void;
};

export const DEFAULT_MAX_ITEMS = 10;

export const useMaxItems = (maxItemsState: MaxItemsState | undefined): MaxItemsState => {
  const [_maxItems, _setMaxItems] = useState(DEFAULT_MAX_ITEMS);
  const { maxItems, initialMaxItems, increaseMaxItems, resetMaxItems } = maxItemsState ?? {
    maxItems: _maxItems,
    initialMaxItems: DEFAULT_MAX_ITEMS,
    increaseMaxItems: () => {
      _setMaxItems((count) => count + DEFAULT_MAX_ITEMS);
    },
    resetMaxItems: () => {
      _setMaxItems(DEFAULT_MAX_ITEMS);
    },
  };

  return { maxItems, initialMaxItems, increaseMaxItems, resetMaxItems };
};
